export const CHeroFragment = `
    fragment hero on hero_MatrixField {
      ... on hero_block_Entry {
        id
        typeHandle
        beforeHeading
        heading
        displayHeadingOnTheSide
        heroContent
        featuredContent
        tooltipText
        tooltipTextPlaceholder
        image {
          url @transform(mode: "crop", width: 800, immediately: true)
          title
          width
          height
          path
        }
        video {
          url
          title
          embeddedAsset {
            title
            url
            providerName
          }
        }
        borders
        displayContinueCta
        cta {
          type
          url
          text
          target
        }
        ctaHeading {
          type
          url
          text
          target
        }
      }
      ... on hero_blockFooter_Entry {
        typeHandle
        heading
        headingSecondary
      }
    }
  `
